import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isSessionValid } from '../services/authStorage';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ permission }) {
  const location = useLocation();
  const { isAuthenticated, hasPermission } = useAuth();

  if (!isSessionValid() || !isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (permission && !hasPermission(permission)) {
    return <Navigate to="/403" replace state={{ required: permission }} />;
  }

  return <Outlet />;
}